import { apiUrl } from "../../constants";
import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getIntegrations = createAsyncThunk(
  "integrations/getIntegrations",
  async (data, thunkAPI) => {
    const state = thunkAPI.getState();
    const token = state.user.token;

    const requestOptions = {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    try {
      const response = await fetch(
        `${apiUrl}/get_department_integrations`,
        requestOptions
      );

      if (!response.ok) {
        let errorMessage = "Network response was not ok";
        try {
          const errorText = await response.text();
          const errorObj = JSON.parse(errorText);
          errorMessage = errorObj.error || errorMessage;
        } catch (e) {
          errorMessage = errorText || errorMessage;
        }
        throw new Error(errorMessage || "Unknown error occurred");
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error("Fetching integrations failed:", error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const getIntegrationsSlice = createSlice({
  name: "integrations",
  initialState: {
    integrations: [],
    status: "idle", // 'idle' | 'loading' | 'success' | 'error'
    error: null,
  },
  reducers: {
    resetGetIntegrationsState(state) {
      state.integrations = [];
      state.status = "idle";
      state.error = null;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getIntegrations.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getIntegrations.fulfilled, (state, action) => {
        state.integrations = action.payload.data;
        state.status = "success";
        state.error = null;
      })
      .addCase(getIntegrations.rejected, (state, action) => {
        state.status = "error";
        state.error = action.payload;
      });
  },
});

export const { resetGetIntegrationsState } = getIntegrationsSlice.actions;
export default getIntegrationsSlice.reducer;
